import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import IconButton from "@material-ui/core/IconButton";
import InputAdornment from "@material-ui/core/InputAdornment";
import FormControl from "@material-ui/core/FormControl";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import { useNavigate } from "react-router-dom";
import { HOST_URL, LOCAL_STORAGE_KEY } from "../../../config";
import { getUserData } from "../../common/utility/Utils";
import CircularProgress from "@material-ui/core/CircularProgress";
import axios from "axios";
import "./updPass.css";
import { CompassCalibrationOutlined } from "@material-ui/icons";
import MainLayout from "../../common/Layout/MainLayout";

function UpdatePassword() {
  // const history = useHistory();
  const navigate = useNavigate();
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [oldValues, setOldValues] = useState({
    password: "",
    showPassword: false
  });

  const [newValues, setNewValues] = useState({
    password: "",
    showPassword: false
  });

  const newhandleChange = (prop) => (event) => {
    setNewValues({ ...newValues, [prop]: event.target.value });
  };

  const oldhandleChange = (prop) => (event) => {
    setOldValues({ ...oldValues, [prop]: event.target.value });
  };

  const oldhandleClickShowPassword = () => {
    setOldValues({ ...oldValues, showPassword: !oldValues.showPassword });
  };

  const newhandleClickShowPassword = () => {
    setNewValues({ ...newValues, showPassword: !newValues.showPassword });
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }
  const [open, setOpen] = useState(false);
  const [alertText, setAlertText] = useState("");
  const [severity, setSeverity] = useState("error");
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  const updPassword = async () => {
    let data = {};
    await getUserData(LOCAL_STORAGE_KEY.user_token)
      .then((res) => {
        data = res;
      })
      .catch((err) => {
        console.log(err);
      });
    const URL = `${HOST_URL}api/v1/AccountData/ChangePassword`;
    if (oldValues.password === "") {
      setOpen(true);
      setSeverity("error");
      setAlertText("Please fill old password!");
    }
    // else if (oldValues.password !== data.password) {
    //     setOpen(true);
    //     setSeverity("error");
    //     setAlertText("Please enter correct password!");
    // }
    else if (newValues.password === "") {
      setOpen(true);
      setSeverity("error");
      setAlertText("Please fill new password!");
    } else if (newValues.password === oldValues.password) {
      setOpen(true);
      setSeverity("error");
      setAlertText("Please fill different new password!");
    } else {
      setLoading(true);
      const params = new URLSearchParams();
      // params.append("ActionName", "Edit")
      params.append("UserName", data.user_name);
      params.append("OldPassword", oldValues.password);
      params.append("NewPassword", newValues.password);
      // const body = {
      //     'UserName': data.user_name,
      //     'OldPassword': oldValues.password,
      //     'NewPassword': newValues.password
      // }
      const header = {
        Authorization: `Bearer ${data.access_token}`,
        UserName: data.user_name,
        UserSecret: data.password,
        DeviceType: "W",
        MacAddress: "",
        IPAddress: ""
      };
      // console.log(body, header)
      axios
        .post(URL, params, {
          headers: header
        })
        .then((res) => {
          setLoading(false);
          console.log("user password reset", res);
          setOpen(true);
          setSeverity("success");
          setAlertText("Password reset successfully");
        })
        .catch((err) => {
          setLoading(false);
          console.log(err);
          setOpen(true);
          setSeverity("error");
          setAlertText("Something went wrong!");
        });
    }
  };

  return (
    <div className="updPassComponent">
      {/* <div className="updPassHeader">
                <h6><span onClick={history.goBack} className="pointer">Go Back</span></h6>
            </div> */}
      <div className="updPassBody">
        <div className="updPassInner">
          <div className="updPassContainer">
            <h6>Update Password</h6>
            <div className="olduserPassword">
              <FormControl className={clsx(classes.margin, classes.textField)}>
                <InputLabel htmlFor="oldpassword">Old Password</InputLabel>
                <Input
                  id="oldpassword"
                  type={oldValues.showPassword ? "text" : "password"}
                  value={oldValues.password}
                  onChange={oldhandleChange("password")}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        onClick={oldhandleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                      >
                        {oldValues.showPassword ? (
                          <Visibility />
                        ) : (
                          <VisibilityOff />
                        )}
                      </IconButton>
                    </InputAdornment>
                  }
                />
              </FormControl>
            </div>
            <div className="olduserPassword">
              <FormControl className={clsx(classes.margin, classes.textField)}>
                <InputLabel htmlFor="newpassword">New Password</InputLabel>
                <Input
                  id="newpassword"
                  type={newValues.showPassword ? "text" : "password"}
                  value={newValues.password}
                  onChange={newhandleChange("password")}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        onClick={newhandleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                      >
                        {newValues.showPassword ? (
                          <Visibility />
                        ) : (
                          <VisibilityOff />
                        )}
                      </IconButton>
                    </InputAdornment>
                  }
                />
              </FormControl>
            </div>
            <div className="updateButton">
              <Button variant="contained" onClick={updPassword}>
                {loading ? (
                  <CircularProgress size="1.5rem" />
                ) : (
                  <span className={loading ? "invisible" : ""}>
                    Update Password
                  </span>
                )}
              </Button>
            </div>
          </div>
        </div>
      </div>
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        open={open}
        autoHideDuration={3000}
        onClose={handleClose}
      >
        <Alert severity={severity} onClose={handleClose}>
          {alertText}
        </Alert>
      </Snackbar>
    </div>
  );
}
const useStyles = makeStyles((theme) => ({
  margin: {
    margin: theme.spacing(1)
  },
  withoutLabel: {
    marginTop: theme.spacing(3)
  }
}));

export default UpdatePassword;
